import React, { useState } from "react";
import { Card, Collapse, Table } from "react-bootstrap";
import { faEdit, faTimes, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditVersionCategoryModal } from "../UpdateVersionCategory/EditVersionCategoryModal";
import { DeleteVersionCategoryModal } from "../UpdateVersionCategory/DeleteVersionCategoryModal";

const AssignedCategoryPage = ({
  sortedCategoriesByParent,
  ogmpCategories,
  versionsCategories,
  expandedParentCategories,
  toggleParentCategory,
  getTechnologyName,
  viewOnly,
  hasAssignedCategories,
  hasOgmpCategories,
  groupVersionId,
  technologies,
  handleEnvChange,
  env,
  currentTenant,
  tenantName
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedParentName, setSelectedParentName] = useState(null);
  const [selectedVersionCategory, setSelectedVersionCategory] = useState(null);

  const openEditModal = (category, versionCategory, parentName) => {
    setSelectedCategory(category);
    setSelectedVersionCategory(versionCategory);
    setSelectedParentName(parentName);
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedCategory(null);
    setSelectedVersionCategory(null);
    setSelectedParentName(null);
  };

  const openDeleteModal = (category, versionCategory) => {
    setSelectedCategory(category);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedCategory(null);
  };

  return (
    <div className="assigned-section">
      {showEditModal && (
        <EditVersionCategoryModal
          show={showEditModal}
          handleClose={closeEditModal}
          category={selectedCategory}
          parentName={selectedParentName}
          versionCategory={selectedVersionCategory}
          groupVersionId={groupVersionId}
          technologies={technologies}
          getTechnologyName={getTechnologyName}
          viewOnly={viewOnly}
          handleEnvChange={handleEnvChange}
          env={env}
          currentTenant={currentTenant}
          tenantName={tenantName}
        />
      )}

      {showDeleteModal && (
        <DeleteVersionCategoryModal
          show={showDeleteModal}
          handleClose={closeDeleteModal}
          groupVersionId={groupVersionId}
          category={selectedCategory}
          handleEnvChange={handleEnvChange}
          env={env}
          currentTenant={currentTenant}
          tenantName={tenantName}
        />
      )}

      {hasOgmpCategories ? (
        <>
          <h4 className="my-2">
            <strong>Assigned OGMP Source Categories</strong>
          </h4>

          {hasAssignedCategories ? (
            sortedCategoriesByParent.map(([parentId, categories]) => {
              // skip this parent group if there are no assigned categories
              if (!categories || categories.length === 0) {
                return null;
              }

              // find a parent category to get its name
              const parentCategory = ogmpCategories.find((cat) => cat.id === parentId);
              const parentName = parentCategory ? parentCategory.name : "No Parent Category";

              return (
                <Card key={parentId} className="mt-3 w-75">
                  <Card.Header
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleParentCategory(parentId)}
                  >
                    <h5 className="mb-0">
                      <strong>{parentName}</strong>
                    </h5>
                    <FontAwesomeIcon icon={expandedParentCategories[parentId] ? faChevronUp : faChevronDown} size="sm" />
                  </Card.Header>
                  <Collapse in={expandedParentCategories[parentId] !== false}>
                    <div>
                      <Card.Body className="p-0">
                        <Table striped bordered hover responsive className="table-sm mb-0">
                          <thead>
                            <tr>
                              <th style={{ width: "250px" }}>Source Category</th>
                              <th>L4 Method</th>
                              <th>Uncertainty</th>
                              <th>Frequency</th>
                              <th>Measurement Technology</th>
                              <th>Data Source</th>
                              <th>Sample Size</th>
                              <th style={{ width: "100px" }}>Unit</th>
                              {!viewOnly && <th style={{ width: "100px" }}>Actions</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {categories?.map((category) => {
                              // find the corresponding version category data
                              const versionCategory = versionsCategories.find((vc) => vc.ogmpCategoryId === category.id);

                              // this should always find a match because we're using pre-filtered assigned categories
                              if (!versionCategory) {
                                console.warn(`No version category found for ${category.id} (${category.name})`);
                                return null;
                              }

                              return (
                                <tr key={category.id}>
                                  <td>{category.name}</td>
                                  <td>{versionCategory.l4Method || "N/A"}</td>
                                  <td>{versionCategory.uncertaintyFraction || "N/A"}</td>
                                  <td>{versionCategory.frequency || "N/A"}</td>
                                  <td>{getTechnologyName(versionCategory.measurementTechnologyId)}</td>
                                  <td>{versionCategory.dataSource || "N/A"}</td>
                                  <td>{versionCategory.sampleSize || "N/A"}</td>
                                  <td>{versionCategory.sampleSizeUnit || "N/A"}</td>
                                  {!viewOnly && (
                                    <td>
                                      <div className="d-flex justify-content-around">
                                        <>
                                          <FontAwesomeIcon
                                            icon={faEdit}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => openEditModal(category, versionCategory, parentName)}
                                          />
                                          <FontAwesomeIcon
                                            icon={faTimes}
                                            style={{ cursor: "pointer", color: "red" }}
                                            onClick={() => openDeleteModal(category)}
                                          />
                                        </>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </Card.Body>
                    </div>
                  </Collapse>
                </Card>
              );
            })
          ) : (
            <h5 className="mt-5">No OGMP source categories assigned to group versions for this tenant</h5>
          )}
        </>
      ) : null}
    </div>
  );
};

export { AssignedCategoryPage };
